import React, { PureComponent } from "react";
import L from "leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import WinterMaintenceUnitLayer from "./WinterMaintenceUnitLayer";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";

class WinterMaintenceParentCompanyLayer extends PureComponent {
  isParentCompanyView() {
    const { filterArea, parentCompany } = this.props;

    return filterArea.parentCompanies.some((x) => {
      return x === parentCompany.id;
    });
  }

  render() {
    const { filterArea, parentCompany, area, colorParentCompanies } = this.props;

    if (!this.isParentCompanyView(parentCompany, filterArea)) {
      return null;
    }

    const createClusterCustomIcon = (cluster) => {
      const markerHtmlStyles = `font-size: 11px;
            font-weight: 600;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            border-radius: 20px;         
            height: 21px;
            width: 21px;            
            background-color: ${colorParentCompanies[parentCompany.id]}dd;`;

      return L.divIcon({
        html: `<div ><span style="${markerHtmlStyles}" >${cluster.getChildCount()}</span></div>`,
        className: styles.winter_marker_cluster,
        iconSize: L.point(25, 25, true),
      });
    };

    return (
      <MarkerClusterGroup iconCreateFunction={createClusterCustomIcon} maxClusterRadius={15}>
        {parentCompany.companies.map((company) => {
          return company.units.map((unit) => {
            return (
              <WinterMaintenceUnitLayer
                key={unit.id}
                parentCompany={parentCompany}
                company={company}
                area={area}
                unit={unit}
                filterArea={filterArea}
              />
            );
          });
        })}
      </MarkerClusterGroup>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceParentCompanyLayer));
